import { API } from '../../../API/config'

const PaymentApis = {
  createTransaction: (billId, mode, subscriptionId) =>
    API.post(`/payment/start/v3`, {
      billId,
      paymentGateway: mode,
      subscriptionId,
      newKeys: true,
    })
      .then((res) => res.data.data)
      .catch(() => false),
  processTransaction: (billId, mode, data) =>
    API.post(`/payment/end`, {
      billId,
      paymentGateway: mode,
      pgData: data,
      newKeys: true,
    })
      .then((res) => res.data.data)
      .catch(() => false),
  redeemDiscountCoupon: (billId, code) =>
    API.put(`/payment/coupon/redeem`, {
      billId,
      code,
    })
      .then((res) => res.data.data)
      .catch(() => false),
  removeDiscountCoupon: (billId) =>
    API.put(`/payment/coupon/de-redeem`, {
      billId,
    })
      .then(() => true)
      .catch(() => false),
}

export default PaymentApis
